import { FC } from "react";
import NoAccountsSvg from "@/assets/icons/noaccounts.svg";
import { LuPlus } from "react-icons/lu";
import { useGlobalStore } from "@/GlobalStore";

interface NoAccountsPageProps {
  onAddAccount: () => void;
}

const NoAccountsPage: FC<NoAccountsPageProps> = ({ onAddAccount }) => {
  const isOauthConnecting = useGlobalStore((state) => state.isOauthConnecting);
  const oauthConnectingPlatformLabel = useGlobalStore(
    (state) => state.oauthConnectingPlatformLabel,
  );

  const platformLabel = oauthConnectingPlatformLabel ?? "Ad";

  return (
    <div className="h-full w-full flex flex-col items-center justify-center text-center">
      <img src={NoAccountsSvg} alt="No accounts" />
      <h2 className="text-[18px] font-medium text-brand-primary-new text-center mb-[10px]">
        {isOauthConnecting ? `Connecting ${platformLabel} Accounts` : "Ready to Advertise?"}
      </h2>
      <p className="text-[#617390] text-center text-[16px] font-normal mb-[31px] max-w-md">
        {isOauthConnecting
          ? "We’re connecting your accounts. This can take a few moments."
          : "Link your ad account now to dive in. Connecting your account is the first step towards reaching your advertising goals."}
      </p>
      {!isOauthConnecting && (
        <button
          className="inline-flex items-center gap-[6px] px-[14px] py-[6px] rounded-[4px] border border-border-gray text-gray-700 hover:bg-gray-50 shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)]"
          onClick={onAddAccount}
        >
          <LuPlus size={14} className="text-brand-primary-new" />
          <span className="overflow-hidden text-brand-primary-new text-ellipsis text-[12px] font-medium leading-[19.157px] tracking-[0.24px]">
            Add Account
          </span>
        </button>
      )}
    </div>
  );
};

export default NoAccountsPage;
